// Maintenance.js
import React from "react";
import { Typography } from "@mui/material";

function Maintenance() {
  return (
    <Typography variant="h4">Maintenance Page - Work in Progress</Typography>
  );
}

export default Maintenance;
